import React from 'react';
export const Header = () => {
  return <div className="flex justify-center py-8" data-id="element-86">
      <img src="https://cdn.magicpatterns.com/uploads/1fyPWMXVhqijtztkRzsHB9/pasted-image.png" alt="HIRE Logo" className="h-[3.25rem]" data-id="element-87" />
    </div>;
};